<div class="modal-signup modal-content" >
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px padding-left-10px">

        Tabular View

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
        <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">
          <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Branch</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="BranchName">{{BranchName}}</label></div>
          </div>
          <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">From Date</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="FromDate">{{FromDate| date:'MMM-dd-yyyy'}}</label></div>
          </div>

          <div class="col-md-4 border-right-1px padding-right-0px padding-left-0px text-align-center">
            <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">To Date</label></div>
            <div><label class="margin-bottom-0px font-size-16px color-Assign font-weight-bold" *ngIf="SelectedToDate">{{SelectedToDate| date:'MMM-dd-yyyy'}}</label></div>
          </div>

       
        </div>
        <!--<div class="row">
          <div class="col-md-12 padding-right-9px padding-left-10px">
            <div class="row font-size-14 margin-top-10 margin-left-0px">
              <div class="col-md-2">
                <h4 class="margin-bottom-0px margin-top-3px">Selected Batch </h4>
              </div>:
              <div class="col-md-7  padding-left-10px my-profile-form">

                <div class="form-group margin-bottom-0px">
              
                  <h4 class="margin-bottom-0px  margin-top-3px"></h4>


                </div>


              </div>

            </div>
          </div>
          
        </div>-->
        <div class="row padding-top-10px">
          <div class="col-md-11 margin-left-15px">
            <h4 class="margin-bottom-0px color-Assign font-size-14 font-weight-bold" *ngIf="ReportType">{{ReportType}}</h4>
          </div>
          <div class="col-md-12">
            <div class="chatsd product-chart-wrapper product-chat-height-335px agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
              <div class="table-component">
                <div class="table-responsive">


                  <table class="table table-striped ">


                    <tbody class="table-body">
                      <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                      <!--</ng-container>-->
                      <tr *ngFor="let p of TableData">



                        <td class="padding-top-0px padding-bottom-0px">{{p.xName}}</td>

                        <td class="padding-top-0px padding-bottom-0px"> {{p.yValue | number:'1.0-0'}}</td>





                      </tr>



                    </tbody>




                  </table>

                </div>
              </div>
              </div>
            </div>
            
          </div>
      </div>
    </div>
  </div>
</div>

